import { Button } from "../../ui/Button"
import {WalletIcon} from "../../../icons/walletIcon"
import { useState } from "react"
import { ToggleButton } from "../../ui/Toggle/ToggleButton"
import { UploadFilesCard } from "../documentation/UploadFilesCard"
import { TextField } from "../../ui/TextField"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/Dropdown"
import { useGetBankOptions } from "../../../hooks/react-query/useOffer"
import { Checkbox } from "../../ui"
import clsx from "clsx"
import { getStandingOrderLink } from "../../../transactions/offer/offer"

const initBankInfoState = {
    enableInstallments:true,
    terms:false,
    bank:'',
    iban:'',
    document:{
        fileArray: [null],
        documentCodesToFriendlyNames: 'Αποδεικτικό δικαιούχου ή συνδικαιούχου λογαριασμού',
        maxFiles: 1,
        helpButton: {url:'',helpContent:'Εκτύπωση απο e-banking οπου φαίνεται ο δικαιούχος του τραπεζικού λογαριασμού'},
        documentAllowedTypes: [
            "pdf",
            "tiff",
            "jfif",
            "gif",
            "bmp",
            "png",
            "jpeg",
            "jpg",
            "webp",
            "tif",
            "pjpeg",
            "avif"
        ]
    }
}

export const InstalmentSection = ({onCompletion}) => {
    const [bankInfo, setBankInfo] = useState(initBankInfoState)
    const [error, setError] = useState('')

    const { data: dropdownData, } = useGetBankOptions();

    const handleTerms = () => {
        getStandingOrderLink().then((data) => {
            const  url  = data.data.link;
            url && window.open(url);
        })
    }

    const handleInstallments = () => {
        if (bankInfo.enableInstallments) {
            let input = bankInfo.iban;
            // Check length
            if (input.length !== 27) {
                setError("Το IBAN πρέπει να αποτελέιται από 27 χαρακτήρες.");
            }
            // Check country code
            else if (input.substring(0, 2) !== "GR") {
                setError("Το IBAN πρέπει να ξεκινάει από 'GR'.");
            }
            // Check format
            else if (!/^[A-Z0-9]{27}$/.test(input)) {
                setError("Invalid IBAN format");
            }
            else {
                onCompletion(bankInfo);
            }
        } else {
            onCompletion(bankInfo);
        }
    }

    return(
        <>
            <div className="flex border-b pb-2  border-b-[#A5A5A5] justify-between">
                <div className="flex gap-2 text-[18px] pl-4 items-center max-lg:w-full">
                    <div className="flex gap-2 items-center">
                        <WalletIcon/>
                        <h5>Πληρωμή</h5>
                    </div>
                    <p className="text-body max-lg:hidden">• Βήμα 2/2 </p>
                    <p className="text-body lg:hidden">Βήμα 2/2 </p>
                </div>
                <Button onClick={()=>{handleInstallments()}} disabled={bankInfo.enableInstallments && (bankInfo.bank ==='' || bankInfo.iban ==='' || bankInfo.document.fileArray[0] === null || !bankInfo.terms)}  className={'max-lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-full text-white text-sm font-[600]'}>Ολοκλήρωση</Button>
            </div>
            <div className="pt-6 flex flex-col gap-6 lg:container lg:mx-auto"> 
                <div className="w-full justify-between flex items-center bg-white py-4 px-6 rounded-[12px]">
                    <div className="flex lg:gap-1 items-center">
                        <h4 className="">Ενεργοποίηση Πάγιας Εντολής <span className="text-body">(Προαιρετικό)</span></h4>
                    </div>
                    <ToggleButton checked={bankInfo.enableInstallments} onCheckedChange={(value) => { if (!value) { setBankInfo({ ...initBankInfoState, enableInstallments:false }); } else { setBankInfo({ ...bankInfo, enableInstallments: true }) } }}/>
                </div>  
                <div className={clsx("p-6 flex flex-col w-full gap-4 bg-white rounded-[12px] max-lg:border max-lg:border-[#E2E2E2]", !bankInfo.enableInstallments && 'opacity-70')}>
                    <div className="flex gap-8 w-full max-lg:flex-col">
                        <div className="flex flex-col gap-2 lg:w-1/2">
                            <div className="flex gap-2 items-center">
                                <h5>Πληροφορίες Λογαριασμού</h5>
                            </div>
                                <p className="text-body">Συμπλήρωσε τα παρακάτω πεδία</p>
                                <div className="flex flex-col gap-1">
                                <p className="text-label text-[#C1C1C1]">Τράπεζα</p>
                                    <Select value={bankInfo.bank} disabled={!bankInfo.enableInstallments} onValueChange={(value)=>{setBankInfo({...bankInfo,bank:value})}}>
                                        <SelectTrigger className="w-[180px]">
                                        <SelectValue placeholder={'Παρακαλώ επιλέξτε'} />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {
                                            dropdownData &&  Object.entries(dropdownData.data).map(([key, value]) =>
                                                    <SelectItem value={key}>{value}</SelectItem>
                                            )}
                                        </SelectContent>
                                    </Select>
                                </div>
                            <TextField error={error} disabled={!bankInfo.enableInstallments} value={bankInfo.iban} onChange={(e)=>{setBankInfo({...bankInfo,iban:e.target.value})}} label={'IBAN'} placeholder={'GRXXXXXXXXXXXXXXXXXXXXX'} />
                        </div> 
                        <UploadFilesCard uploadCase={bankInfo.document} className={' col-span-2'} onChange={(updatedArray, index) => { setBankInfo({ ...bankInfo, document: {...bankInfo.document, fileArray: updatedArray } })}}/>
                    </div>
                        <div className="flex gap-2 items-center lg:px-4">
                        <Checkbox
                            checked={bankInfo.terms}
                            onCheckedChange={() => { setBankInfo({ ...bankInfo, terms: !bankInfo.terms }) }}
                        />
                        <p className="text-label">Ενημερώθηκα και αποδέχομαι τους <Button onClick={handleTerms} className={'text-[#D4002A]'}>Όρους και Προϋποθέσεις </Button> ενεργοποίησης Πάγιας Εντολής</p>
                    </div>
                </div>
            </div>
            <Button onClick={()=>{handleInstallments()}} disabled={bankInfo.enableInstallments && (bankInfo.bank ==='' || bankInfo.iban ==='' || bankInfo.document.fileArray[0] === null || !bankInfo.terms)}  className={'lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 mt-4 rounded-[6px] text-white text-sm font-[600] w-full'}>Ολοκλήρωση</Button>    
           
        </>
    )
}